export const MARKETPLACE_CHECKOUT_OPEN_EVENT = "convoke:marketplace-checkout-open";
export const MARKETPLACE_CATALOG_INVALIDATED_EVENT = "convoke:marketplace-catalog-invalidated";

export const openMarketplaceCheckoutPanel = ({ offerKey, resourceKey = "", showPaymentFollowUp = false }) => {
  const normalizedOfferKey = String(offerKey || "").trim();
  if (!normalizedOfferKey || typeof window === "undefined") {
    return false;
  }

  window.dispatchEvent(new CustomEvent(MARKETPLACE_CHECKOUT_OPEN_EVENT, {
    detail: {
      offerKey: normalizedOfferKey,
      resourceKey: String(resourceKey || "").trim(),
      showPaymentFollowUp: showPaymentFollowUp === true
    }
  }));
  return true;
};

export const invalidateMarketplaceCatalog = () => {
  if (typeof window === "undefined") return false;
  window.dispatchEvent(new CustomEvent(MARKETPLACE_CATALOG_INVALIDATED_EVENT));
  return true;
};

export const isClientOfferActive = (offer) => {
  const lifecycleStatus = Number(offer?.lifecycleStatus ?? offer?.LifecycleStatus ?? 0);
  const approvalStatus = Number(offer?.approvalStatus ?? offer?.ApprovalStatus ?? 0);
  return ![8, 9].includes(lifecycleStatus) && approvalStatus === 3;
};

export const hasActiveClientOffer = (clientProductOffers, offerKey) =>
  (clientProductOffers || []).some((offer) =>
    isClientOfferActive(offer)
    && String(offer?.productOfferKey || offer?.ProductOfferKey || "").toLowerCase()
      === String(offerKey || "").toLowerCase()
  );

export const isClientOfferPendingPayment = (offer) => {
  const lifecycleStatus = Number(offer?.lifecycleStatus ?? offer?.LifecycleStatus ?? 0);
  const approvalStatus = Number(offer?.approvalStatus ?? offer?.ApprovalStatus ?? 0);
  return lifecycleStatus === 10 && approvalStatus === 2;
};

export const hasPendingClientOffer = (clientProductOffers, offerKey) =>
  (clientProductOffers || []).some((offer) =>
    isClientOfferPendingPayment(offer)
    && String(offer?.productOfferKey || offer?.ProductOfferKey || "").toLowerCase()
      === String(offerKey || "").toLowerCase()
  );
